/* eslint-disable @typescript-eslint/no-non-null-assertion,@typescript-eslint/consistent-type-assertions */
import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { repository } from "~/clientInstance";
import { CommunityActionTemplateList } from "~/components/ActionTemplates/CommunityActionTemplateList";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import FilterSearchBox from "~/components/FilterSearchBox/FilterSearchBox";
import { PaperLayoutVNext } from "~/components/PaperLayout/PaperLayoutVNext";
import Section from "~/components/Section";
import { timeOperationOptions } from "~/utils/OperationTimer/timeOperation";
import LibraryLayout from "../LibraryLayout/LibraryLayout";
import styles from "./style.module.less";
interface CommunityTemplatesPageProps {
    spaceId: string;
}
interface CommunityTemplatesPageState extends DataBaseComponentState {
    templates: ActionTemplateSearchResource[];
    isLoaded: boolean;
    filterText?: string;
    projectIdToComeBackTo?: string;
}
export class CommunityTemplatesPage extends DataBaseComponent<CommunityTemplatesPageProps, CommunityTemplatesPageState> {
    constructor(props: CommunityTemplatesPageProps) {
        super(props);
        this.state = {
            templates: null!,
            isLoaded: false,
            filterText: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const templates = await repository.ActionTemplates.search();
            this.setState({
                templates: templates.filter((t) => !t.IsInstalled),
                isLoaded: true,
            });
        }, { timeOperationOptions: timeOperationOptions.forInitialLoad() });
    }
    render() {
        return (<LibraryLayout spaceId={this.props.spaceId}>
                <PaperLayoutVNext title="Choose Step Template" breadcrumbsItems={[{ label: "Step Templates", pageUrl: links.stepTemplatesPage.generateUrl({ spaceId: this.props.spaceId }) }]} fullWidth={true} busy={this.state.busy} errors={this.errors}>
                    {this.state.isLoaded && (<>
                            <Section>
                                <FilterSearchBox placeholder="Filter by name, category or description..." onChange={(value) => this.setState({ filterText: value.toLowerCase() })} fullWidth={true} autoFocus={true} containerClassName={styles.filterSearchBoxContainer}/>
                            </Section>
                            <CommunityActionTemplateList spaceId={this.props.spaceId} templates={this.state.templates} installationActionName="Install" onPostSelectionUrlRequested={(template) => links.stepTemplatesPage.generateUrl({ spaceId: this.props.spaceId })} onDetailsUrlRequested={(template) => links.communityStepTemplatePage.generateUrl({ spaceId: this.props.spaceId, templateId: template.CommunityActionTemplateId! })} filter={this.state.filterText}/>
                        </>)}
                </PaperLayoutVNext>
            </LibraryLayout>);
    }
    static displayName = "CommunityTemplatesPage";
}
